import { render } from "./MonitorInstructionTitle.vue?vue&type=template&id=d1024f68&scoped=true"
import script from "./MonitorInstructionTitle.vue?vue&type=script&lang=js"
export * from "./MonitorInstructionTitle.vue?vue&type=script&lang=js"

import "./MonitorInstructionTitle.vue?vue&type=style&index=0&id=d1024f68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1024f68"]])

export default __exports__